import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import { formatCurrencyForTable, formatDateForTable, getBooleanStatusBadgeColors } from '../utils/formatters';
export const createShippingMethodColumns = () => [
    {
        key: 'name',
        header: 'Method',
        sortable: true,
        render: (method) => method.name || 'N/A',
    },
    {
        key: 'price',
        header: 'Price',
        sortable: true,
        render: (method) => formatCurrencyForTable(Number(method.price || 0)),
    },
    {
        key: 'is_free',
        header: 'Free',
        sortable: true,
        render: (method) => {
            const isFree = !!method.is_free;
            const label = isFree ? 'Free' : 'Paid';
            const { background, text } = getBooleanStatusBadgeColors(isFree);
            return (_jsx(StatusBadge, { label: label, bgColor: background, color: text }));
        },
    },
    {
        key: 'is_default',
        header: 'Default',
        sortable: true,
        render: (method) => {
            const isDefault = !!method.is_default;
            const label = isDefault ? 'Default' : 'No';
            const { background, text } = getBooleanStatusBadgeColors(isDefault);
            return (_jsx(StatusBadge, { label: label, bgColor: background, color: text }));
        },
    },
    {
        key: 'estimated_days',
        header: 'Estimated Days',
        sortable: true,
        render: (method) => {
            const days = Number(method.estimated_days || 0);
            return days > 0 ? `${days} day${days === 1 ? '' : 's'}` : 'N/A';
        },
    },
    {
        key: 'updated_at',
        header: 'Updated',
        sortable: true,
        render: (method) => formatDateForTable(method.updated_at || method.created_at),
    },
];
